import { FC } from 'react';
import cn from 'classnames';
import { ElementThemeUnion } from 'constants/routes';

import { genericMemo } from 'utils';

import Option from './Option';
import SearchInput from './SearchInput';

interface DropdownProps {
  options: { label: string; value: number }[];
  value: string[];
  onSelect: (option: string) => void;
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;

  searchInputRef?: React.Ref<HTMLInputElement>;
  searchPlaceholder?: string;
  theme?: ElementThemeUnion;
}

const Dropdown: FC<DropdownProps> = ({
  options,
  value,
  onSelect,
  searchQuery,
  setSearchQuery,
  searchInputRef,
  searchPlaceholder = '',
  theme,
}) => {
  const backgroundClass = theme === 'light' ? 'bg-light' : 'bg-ultrablack';

  const searchFilteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div
      className={cn(
        'absolute z-50 w-full max-h-[185px] rounded-lg border border-tpg_light border-solid flex flex-col overflow-hidden cursor-pointer',
        backgroundClass
      )}
    >
      <SearchInput
        ref={searchInputRef}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        searchPlaceholder={searchPlaceholder}
        theme={theme}
      />
      <div className="overflow-auto">
        {searchFilteredOptions.map((option) => (
          <Option
            key={option.value}
            searchQuery={searchQuery}
            option={option}
            onToggle={() => onSelect(option.label)}
            isAdded={value.includes(option.label)}
            theme={theme}
          />
        ))}
      </div>
      {value.length > 0 && (
        <div
          className={cn(
            'w-full flex items-start justify-start transition-colors duration-200 ease-in-out border-t border-solid border-tpg_light px-4 py-2'
          )}
        >
          <span className="uppercase text-tpg_base tpg-c2">
            {value.join(', ')}
          </span>
        </div>
      )}
    </div>
  );
};

export default genericMemo(Dropdown);
